import React, { type PropsWithChildren, type FC, useContext } from 'react';

import { useSmartlingStrings } from '@lucid/hooks';

import LayoutContext from '../../context/layout-context';
import Text from '../../text/text';
import type { CardTextProps } from './text';

export type CardLabelProps = CardTextProps & {
  /** - For Template Cards - Will render additional "Made by" text before label  */
  isAttribution?: boolean;
};

const CardLabel: FC<PropsWithChildren<CardLabelProps>> = ({ variant = 'labelS400', isAttribution, value }) => {
  const { shortCode } = useContext(LayoutContext);
  const withSmartling = useSmartlingStrings({
    keys: ['mktg_template_made_by'],
    shortCode,
  });

  return (
    value && (
      <Text css={theme => ({ label: 'cardLabel', marginBottom: `-${theme.space.s16}px` })} variant={variant}>
        {isAttribution && (
          <Text as="span" css={theme => ({ color: theme.colors.primary })} variant="labelS500">
            {withSmartling('mktg_template_made_by') || 'Made by '}
          </Text>
        )}
        {value}
      </Text>
    )
  );
};

export { CardLabel };
export default CardLabel;
